
import { Bell, BellRing } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Badge } from '@/components/ui/badge';
import { useNotifications } from '@/hooks/useNotifications';
import { NotificationList } from './NotificationList';

export const NotificationBell = () => {
  const notificationHook = useNotifications();
  
  // Add error boundary protection
  if (!notificationHook) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              variant="secondary" 
              size="icon" 
              className="relative h-12 w-12 rounded-full shadow-md"
            >
              <Bell className="h-5 w-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Notifications</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  const { unreadCount = 0, refresh } = notificationHook;

  // Debug: Log when unreadCount changes
  console.log('🔔 NotificationBell render - unreadCount:', unreadCount);

  return (
    <TooltipProvider>
      <Tooltip>
        <Popover>
          <PopoverTrigger asChild>
            <TooltipTrigger asChild>
              <Button 
                variant="secondary" 
                size="icon" 
                className="relative h-12 w-12 rounded-full shadow-md"
              >
                {unreadCount > 0 ? (
                  <BellRing className="h-5 w-5" />
                ) : (
                  <Bell className="h-5 w-5" />
                )}
                {unreadCount > 0 && (
                  <Badge 
                    variant="destructive" 
                    className="absolute -top-1 -right-1 h-5 min-w-5 flex items-center justify-center p-0 text-xs"
                  >
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </Badge>
                )}
              </Button>
            </TooltipTrigger>
          </PopoverTrigger>
          <PopoverContent className="w-80 p-0" align="end" side="top">
            <NotificationList />
          </PopoverContent>
        </Popover>
        <TooltipContent>
          <p>Notifications {unreadCount > 0 ? `(${unreadCount} unread)` : ''}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
